export default __webpack_public_path__ + "static/how-we-succeed-featured-img-fdf26d7030f9ff1aaa628dd31a32c0d2.webp";